import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';

const HeadTitle = ({ title = '' }) => (
  <Helmet>
    <title>{title}</title>
  </Helmet>
);

HeadTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

export default HeadTitle;
